import { PaymentRequirementsField, PaymentRequirementsItemSignData } from "../api/incoming/payment-requirements-incoming.interface";

export const paymentRequirementsCreateSignMappedKeys:
	(keyof PaymentRequirementsItemSignData)[] = [
	PaymentRequirementsField.documentNumber,
	PaymentRequirementsField.documentDate,
	PaymentRequirementsField.debitName,
	PaymentRequirementsField.debitInn,
	PaymentRequirementsField.debitPinfl,
	PaymentRequirementsField.debitAccountNumber,
	PaymentRequirementsField.debitMfo,
	PaymentRequirementsField.requesterName,
	PaymentRequirementsField.requesterInn,
	PaymentRequirementsField.requesterPinfl,
	PaymentRequirementsField.requesterAccountNumber,
	PaymentRequirementsField.requesterMfo,
	PaymentRequirementsField.purposeCode,
	PaymentRequirementsField.purpose,
];